import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { getTemplatesCall } from '../api';

export const useCurrentTemplate = () => {
  const { surveyId } = useParams();
  const { response: responseGetTemplates } = getTemplatesCall.hook();

  const isHardSkillSurvey = useMemo(() => {
    const surveyTemplate = responseGetTemplates?.find(template => template.id === surveyId);
    return surveyTemplate?.name === 'Hard skills';
  }, [responseGetTemplates, surveyId]);

  const isSoftSkillSurvey = useMemo(() => {
    const surveyTemplate = responseGetTemplates?.find(template => template.id === surveyId);
    return surveyTemplate?.name === 'Soft skills';
  }, [responseGetTemplates, surveyId]);

  const currentName = useMemo(() => {
    const surveyTemplate = responseGetTemplates?.find(template => template.id === surveyId);
    return surveyTemplate?.name || '';
  }, [responseGetTemplates, surveyId]);

  const currentTemplateId = useMemo(() => {
    const surveyTemplate = responseGetTemplates?.find(template => template.id === surveyId);
    return surveyTemplate?.id || '';
  }, [responseGetTemplates, surveyId]);

  return {
    isHardSkillSurvey,
    isSoftSkillSurvey,
    currentName,
    currentTemplateId,
  };
};
